import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { TextField, type TextFieldProps } from '@/components/atoms/TextField';

export type FormFieldProps = {
  label: ReactNode;
  id?: string;
  textFieldProps?: Omit<TextFieldProps, 'id' | 'label'>;
};

export function FormField({ label, id, textFieldProps }: FormFieldProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Typography
        component="label"
        htmlFor={id}
        sx={{
          fontSize: 12,
          lineHeight: '23.375px',
          fontWeight: 400,
          color: '#1e2a39',
        }}
      >
        {label}
      </Typography>
      <TextField id={id} {...textFieldProps} />
    </Box>
  );
}
